import classNames from 'classnames'

import { QA_NAME_SIDE_SECTION, QA_SECTION_KEY } from '../../../constants/qa'
import { getQaSelector } from '../../../utils/common'

import * as styles from './PageWidgetsContainer.module.css'

function PageWidgetsContainer({
  children,
  className,
  contentClassName,
  qaName = QA_NAME_SIDE_SECTION,
}) {
  const containerClassName = classNames(
    styles.scrollWrapper,
    styles.widgetsContainer,
    className
  )

  const sectionQaProps = getQaSelector({ value: qaName }, QA_SECTION_KEY)

  return (
    <div {...sectionQaProps} className={containerClassName}>
      <div
        className={classNames(
          styles.content,
          styles.widgetsContent,
          contentClassName
        )}
      >
        {children}
      </div>
    </div>
  )
}

export default PageWidgetsContainer
